import { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import SwitchVertical01 from "@untitled-ui/icons-react/build/esm/SwitchVertical01";
import { FaSearch } from "react-icons/fa";
import { TrashIcon } from "../../../../../assets/icons";
import { formatDate } from "../../../../utils/_generic";
import PDLTypography from "../../../components/dna/_pdltypography";
import { SortOrder } from "../../../components/_saveDateFilter";
import { Pagination } from "../../../components/global";
import "./index.scss";
import { SearchInfo } from "../../../../services/get-saved-searches";

interface SavedSearchesListProps {
  searches: SearchInfo[];
  onDeleteAll?: () => void;
  onDelete?: (id: string) => void;
  onSortChange?: (order: SortOrder) => void;
  onRun?: (id: string) => void;
  currentOrder?: SortOrder;
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const SavedSearchesList = ({
  searches,
  onDeleteAll,
  onDelete,
  onSortChange,
  onRun,
  currentOrder,
  currentPage,
  totalPages,
  onPageChange,
}: SavedSearchesListProps) => {
  const [sortOrder, setSortOrder] = useState<SortOrder>(currentOrder ?? "desc");

  const handleSortChange = (order: SortOrder) => {
    setSortOrder(order);
    onSortChange?.(order);
  };

  return (
    <div className="saved-searches-list">
      <div className="saved-searches-header">
        <button type="button" className="btn-delete-all" onClick={onDeleteAll}>
          <TrashIcon color="#8c0000" />
          <span>Apagar pesquisas salvas</span>
        </button>
        <DropdownButton
          variant="outline-secondary"
          title={
            <>
              <SwitchVertical01 className="me-2" />
              {sortOrder === "desc" ? "Mais recentes" : "Mais antigos"}
            </>
          }
          id="dropdown-sort-options"
        >
          <Dropdown.Item onClick={() => handleSortChange("desc")}>
            Mais recentes
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleSortChange("asc")}>
            Mais antigos
          </Dropdown.Item>
        </DropdownButton>
      </div>

      {searches.length === 0 ? (
        <PDLTypography size="sm" className="text-muted mt-4">
          Nenhuma pesquisa salva encontrada
        </PDLTypography>
      ) : (
        <div className="saved-searches-table">
          <div className="table-header">
            <div className="header-cell">Pesquisa</div>
            <div className="header-cell header-cell-center">
              Tipo de pesquisa
            </div>
            <div className="header-cell header-cell-center">
              Data da pesquisa
            </div>
            <div className="header-cell"></div>
          </div>

          {searches.map((search) => (
            <div key={search._id} className="table-row">
              <div className="table-cell">{search.nome}</div>
              <div className="table-cell table-cell-center">
                {search.tipo || "Tudo"}
              </div>
              <div className="table-cell table-cell-center">
                {formatDate(search.data)}
              </div>
              <div className="table-cell table-cell-actions">
                <button
                  type="button"
                  className="btn-delete-item"
                  onClick={() => onDelete?.(search._id)}
                  title="Excluir pesquisa"
                >
                  <TrashIcon color="#8c0000" />
                </button>
                <button
                  type="button"
                  className="btn-action-item"
                  onClick={() => onRun?.(search._id)}
                  title="Realizar pesquisa"
                >
                  <FaSearch color="#344054" />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
      {searches.length > 0 && (
        <div className="mt-4">
          <Pagination
            currentPage={currentPage || 1}
            totalPages={totalPages || 1}
            onPageChange={onPageChange || (() => {})}
            showFirstLast={true}
            showPrevNext={true}
            maxVisiblePages={5}
            size="md"
          />
        </div>
      )}
    </div>
  );
};

export default SavedSearchesList;
